import { getBaseApi } from "../api";
import type { Filter, Opportunity } from "../types";

const api = getBaseApi();

export const getOpportunities = async (
  filter: Filter & { workspace?: string }
) => {
  const searchParams = new URLSearchParams();
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  const response = await api.get(`/opportunities?${searchParams.toString()}`);
  return response.data;
};

export const getOpportunity = async (id: string) => {
  const response = await api.get(`/opportunities/${id}`);
  return response.data?.data;
};

export const createOpportunity = async (data: Opportunity) => {
  return api.post(`/opportunities`, data);
};

export const updateOpportunity = async (id: string, data: any) => {
  return api.put(`/opportunities/${id}`, data);
};

export const deleteOpportunity = async (id: string) => {
  return api.delete(`/opportunities/${id}`);
};

export const updateOpportunityStatus = async (
  id: string,
  data: { status: string }
) => {
  return api.patch(`/opportunities/${id}/status`, data);
};

export const applyToOpportunity = async (
  id: string,
  data: {
    contactPersonName: string;
    contactPersonEmail: string;
    contactPersonPhone: string;
    experienceFile?: string;
    additionalFile?: string;
    customResponses?: Array<{
      questionId: string;
      questionLabel: string;
      response?: string | number | string[];
      files?: Array<{
        name: string;
        url: string;
      }>;
    }>;
  }
) => {
  return api.post(`/opportunities/${id}/applications`, data);
};

export const getOpportunityApplications = async (
  opportunityId: string,
  filter?: Filter & { workspace?: string }
) => {
  const searchParams = new URLSearchParams();
  if (filter) {
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, String(value));
      }
    });
  }
  const queryString = searchParams.toString();
  const response = await api.get(
    `/opportunities/${opportunityId}/applications${queryString ? `?${queryString}` : ""}`
  );
  return response.data;
};

export const getOpportunityApplication = async (
  opportunityId: string,
  applicationId: string
) => {
  const response = await api.get(
    `/opportunities/${opportunityId}/applications/${applicationId}`
  );
  return response.data?.data;
};

export const deleteOpportunityApplication = async (
  opportunityId: string,
  applicationId: string
) => {
  return api.delete(
    `/opportunities/${opportunityId}/applications/${applicationId}`
  );
};
